import React from 'react';
import { Box, Typography } from '@mui/material';
import styled from 'styled-components';
import { theme } from "./../../../../../../Customization/Theme";
import NoProduct from "../../../../../../assets/images/no_product_found.svg";
const DetailsContainer = styled(Box)`
  padding: 16px;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const FlexRow = styled(Box)`
  display: flex;
  justify-content: space-between;
  gap: 16px;
`;

const Section = styled(Box)`
  flex: 1;
  font-size:13px;
  font-family: Rubik, Helvetica, sans-serif;
  color: ${theme.palette.default.darkGrey};
  text-align: left;

  .title{
      color: ${theme.palette.default.black};
  }
`;

const ProductList = styled(Box)`
  margin-top: 16px;
`;

const ProductHeader = styled(Box)`
  display: flex;
  justify-content: space-between;
  padding: 8px;
  // border-bottom: 2px solid #ccc;
  font-weight: bold;
  text-align: left;
`;

const ProductRow = styled(Box)`
  display: flex;
  justify-content: space-between;
  padding: 8px 16px;
  margin:8px 0px;
  align-items: center;
  background-color: #f9f9f9;
  border-radius: 8px;
`;

const ProductImage = styled.img`
  width: 50px;
  height: 50px;
  object-fit: cover;
  margin-right: 8px;
  border: 1px solid #adadad;
  border-radius: 10%;
`;

const ProductInfo = styled(Box)`
  display: flex;
  align-items: center;
  flex: 2; /* Ensure consistent width with header */
`;

const ProductDetails = styled(Box)`
  display: flex;
  justify-content: space-between;
  flex: 3; /* Adjust width to align properly with header */
`;
interface AccordionDetailsProps {
  order:any;
}
const AccordionDetails: React.FC<AccordionDetailsProps> = ({order}) => {

  return (
    <DetailsContainer>
      <FlexRow>
        {/* General Section */}
        <Section>
          <Typography className='title' variant="body1">General</Typography>
          <Typography variant="body2">Order ID: {order?.order_id}</Typography>
          <Typography variant="body2">Order Name: {order?.order_name}</Typography>
          <Typography variant="body2">Payment Method: {order?.payment_method}</Typography>
          <Typography variant="body2">Created Time: {order?.order_created_time?.toLocaleString()}</Typography>
          <Typography variant="body2">Modified Time: {order?.order_modified_time?.toLocaleString()}</Typography>
        </Section>

        {/* Billing Section */}
        <Section>
          <Typography className='title' variant="body1">Billing</Typography>
          <Typography variant="body2">Name: {order?.billing_first_name} {order?.billing_last_name}</Typography>
          <Typography variant="body2">City: {order?.billing_city}</Typography>
          <Typography variant="body2">State: {order?.billing_state}</Typography>
          <Typography variant="body2">Country: {order?.billing_country}</Typography>
          <Typography variant="body2">ZIP: {order?.billing_zip}</Typography>
        </Section>

        {/* Shipping Section */}
        <Section>
          <Typography className='title' variant="body1">Shipping</Typography>
          <Typography variant="body2">Name: {order?.shipping_first_name} {order?.shipping_last_name}</Typography>
          <Typography variant="body2">City: {order?.shipping_city}</Typography>
          <Typography variant="body2">State: {order?.shipping_state}</Typography>
          <Typography variant="body2">Country: {order?.shipping_country}</Typography>
          <Typography variant="body2">ZIP: {order?.shipping_zip}</Typography>
        </Section>
      </FlexRow>

      {/* Products Section */}
      <ProductList>
        <Typography variant="body1">Products</Typography>
        
        <ProductHeader>
          <Box flex={2}>Item</Box>
          <Box flex={1}>Cost</Box>
          <Box flex={1}>Quantity</Box>
          <Box flex={1}>Total</Box>
        </ProductHeader>

        {order?.products.map((product: any) => (
          <ProductRow key={product?.id}>
            <ProductInfo>
              <ProductImage src={product?.images?.[0] || NoProduct} alt={product?.title} />
              <Typography variant="body2">{product.title}</Typography>
            </ProductInfo>
            <ProductDetails>
              <Typography flex={1} variant="body2">₹{product?.price || 0}</Typography>
              <Typography flex={1} variant="body2">x{product?.quantity || 0}</Typography>
              <Typography flex={1} variant="body2">₹{product?.price && product?.quantity ? (product?.price * product?.quantity).toFixed(2) : 0}</Typography>
            </ProductDetails>
          </ProductRow>
        ))}
      </ProductList>
    </DetailsContainer>
  );
};

export default AccordionDetails;